<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="display:block;top:0"></div>
    
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" style="display:block;">
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">자동이체 계좌 등록 신청</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <ul class="rew19_linetab_pop nav nav-tabs nav-stacked">
        <li :class="{active:viewData.processStep==1}"><a>약관동의</a></li>
        <li :class="{active:viewData.processStep==2}"><a>계좌등록 신청</a></li>
        <li :class="{active:viewData.processStep==3}"><a>신청완료</a></li>
      </ul>
      
      <!--STEP 1-->
      <div v-show="viewData.processStep==1" 
        class="tab-pane fade in active">
        <div class="rew19_popup_cont tab-content">                
          <span class="rew19_infoStar">자동이체는 금융결제원을 통하여 신청 등록되며, 정기구매에서 이용 가능합니다. 영업일을 기준으로 등록 및 출금 절차가 이루어지므로 출금일자는 매월 변경될 수 있습니다.</span>

          <div class="rew19_termwrap">
            <h4>자동 계좌이체 약관</h4>
            <div v-html="bankAccountRegTerm" class="rew19_termbox">
              
            </div>
            <div class="rew19_wrapCheck_t1">
              <input 
                v-model="viewData.step1.isTermCheck" 
                ref="step1.termCheck"
                id="account_term01"
                type="checkbox" class="rew19_fakeCheck_t1">
              <label for="account_term01">약관에 동의합니다</label>
            </div>
          </div>            
        </div><!--//rew19_popup_cont-->
        
        <div class="rew19_popup_btn rew19_clear">
          <button @click="onCancel" class="rew19_popHarf disabled">미동의</button>
          <button @click="onClickStep1Ok" class="rew19_popHarf activation">약관동의</button>
        </div>        
      </div><!--ID tab1-->
      <!--// STEP 1-->

      <!--STEP 2-->
      <div v-show="viewData.processStep==2" 
        class="tab-pane fade in active">
        <div class="rew19_popup_cont tab-content">
          <dl class="rew19_select_table">
            <dt>
              <span class="rew19_table_tit">신청자 정보 입력</span>
            </dt>
            <dd>
              <ul class="rew19_transition_table">
                <li>
                  <em class="with_type1">신청자</em>
                  <div class="txt_type">{{getMemberNmKr()}} ({{getMemberId()}})</div>
                </li>
                <li>
                  <em class="with_type1">연락처</em>
                  <div class="phone_type">
                    <div class="rew19_form_full">
                      <input 
                        v-model.trim="viewData.step2.mobilePhoneNum1"
                        ref="step2.mobilePhoneNum1"
                        @keypress="numberKeyPress($event)"
                        @keyup="keyUpToNumber($event)"
                        @change="onChnageMobilePhone"
                        maxlength="3"
                        title="연락처 입력" type="tel" 
                        class="autoFocus onlynum rew19_inputTxt_t1" placeholder="010">
                    </div>
                    <div class="rew19_form_full">
                      <input 
                        v-model.trim="viewData.step2.mobilePhoneNum2"
                        ref="step2.mobilePhoneNum2"
                        maxlength="4"
                        @keypress="numberKeyPress($event)"
                        @keyup="keyUpToNumber($event)"
                        @change="onChnageMobilePhone"
                        title="연락처 입력" type="tel" class="autoFocus onlynum rew19_inputTxt_t1"
                        placeholder="0000">
                    </div>
                    <div class="rew19_form_full">
                      <input 
                        v-model.trim="viewData.step2.mobilePhoneNum3"
                        ref="step2.mobilePhoneNum3"
                        maxlength="4"
                        @keypress="numberKeyPress($event)"
                        @keyup="keyUpToNumber($event)"
                        @change="onChnageMobilePhone"
                        title="연락처 입력" type="tel" 
                        class="autoFocus onlynum rew19_inputTxt_t1" placeholder="0000">
                    </div>
                    <span class="type1">
                      <a @click="openSmsApprovalDialog" class="rew19_btn_T1"><i>휴대폰</i> 인증</a>
                    </span>
                  </div>
                </li>
              </ul>
            </dd>
            <dt>
              <span class="rew19_table_tit">계좌이체(CMS) 정보</span>
            </dt>
            <dd>
              <ul class="rew19_transition_table">
                <li>
                  <em class="with_type1">결제은행</em>
                  <div class="rew19_form_full">
                    <select 
                      v-model.trim="viewData.step2.bankInfo"
                      ref="step2.bankInfo"                      
                      @change="onChnageBankAccount"
                      title="결제은행 선택" class="rew19_select_t1 autoFocus">                      
                      <option v-for="(item) in viewData.step2.bankList" :key="item.bankCode"
                       :value="item">{{item.bankName}}</option>
                    </select>
                  </div>
                </li>
                <li>
                  <em class="with_type1">예금주</em>
                  <div class="rew19_form_full">
                    <input 
                      v-model.trim="viewData.step2.depositor"
                      ref="step2.depositor"                      
                      @change="onChnageBankAccount"
                      title="예금주 이름 입력" type="text" class="autoFocus rew19_inputTxt_t1" placeholder="예금주 이름 입력">
                  </div>
                </li>
                <li>
                  <em class="with_type1">계좌번호</em>
                  <div class="right_btn">
                    <div class="rew19_form_full">
                      <input 
                        v-model.trim="viewData.step2.bankAccount"
                        ref="step2.bankAccount"
                        @keypress="numberKeyPress($event)"
                        @keyup="keyUpToNumber($event)"
                        @change="onChnageBankAccount"
                        title="계좌번호 입력" type="tel" class="autoFocus onlynum rew19_inputTxt_t1" placeholder="숫자만 입력">
                    </div>
                    <span class="type1">
                      <a @click="onClickCheckAccountInfo"
                        class="rew19_btn_T1">계좌인증</a>
                    </span>
                  </div>
                </li>
                <li>
                  <em class="with_type1">생년월일</em>
                  <div class="rew19_form_full">
                    <input 
                      v-model.trim="viewData.step2.birthday"
                      ref="step2.birthday"
                      maxlength="6"
                      @keypress="numberKeyPress($event)"
                      @keyup="keyUpToNumber($event)"
                      title="생년월일 입력" type="tel" class="autoFocus rew19_inputTxt_t1" placeholder="주민등록 번호 앞 6자리">
                  </div>
                </li>
                <!--
                <li>
                  <em class="with_type1">신청일</em>
                  <div class="txt_type">2019-07-30</div>
                </li>
                -->
              </ul>
            </dd>
            <dt>
              <span class="rew19_table_tit">계좌이체(CMS) 증빙자료 첨부</span>
            </dt>
            <dd>
              <ul class="rew19_transition_table">
                <li>
                  <em class="with_type1">동의서 첨부</em>
                  <div class="right_btn">
                    <div class="rew19_form_full">
                      <input 
                        ref="step2.fakePath"
                        readonly
                        title="첨부파일명" type="text" 
                        class="autoFocus rew19_inputTxt_t1" placeholder="동의서를 첨부해 주세요.">
                    </div>
                    <span class="type1 rew19_filebox">
                      <label for="ex_file" class="rew19_btn_T1">파일선택</label>
                      <input 
                        ref="step2.attachFile"
                        @change="onChangeAttachFile"
                        type="file" id="ex_file" accept="image/*">
                    </span>
                  </div>
                </li>
                <li>
                  <em class="with_type1">동의서 양식 받기</em>
                  <div class="btns">
                    <span class="type1">
                      <a href="https://resource2018.nuskinkorea.co.kr/files/withdrawalForm_sample_up.hwp"
                        target="_blank"
                        class="rew19_btn_T3 iconH"><i>한글 </i>다운받기</a>
                    </span>
                    <span class="type1">
                      <a href="https://resource2018.nuskinkorea.co.kr/files/withdrawalForm_sample_up.rtf"
                        target="_blank"
                        class="rew19_btn_T3 iconW"><i>워드 </i>다운받기</a>
                    </span>
                    <span class="type1">
                      <a href="https://resource2018.nuskinkorea.co.kr/files/withdrawalForm_sample_up.pdf"
                        target="_blank"
                        class="rew19_btn_T3 iconP"><i>PDF </i>다운받기</a>
                    </span>
                  </div>
                </li>
              </ul>
            </dd>
          </dl>
          <ul class="rew19_dotList topLine">
            <li>모바일에서는 증빙서류 다운로드 및 작성이 어려울 수 있습니다. 증빙서류 작성은 PC에서 진행하시면 더욱 편리합니다.</li>
            <li>동의서 양식을 받아서 출력 후 작성 및 서명하시고, 사진이나 스캔을 받아 첨부해 주셔야 자동이체 신청이 가능합니다. 파일은 jpg 파일만 가능합니다.</li>
            <li>동의서에 개인정보 수집 및 이용 동의, 개인정보 제3자 제공 동의에 반드시 체크하셔야 합니다.</li>
            <li>2016년 6월 27일부터 바뀐 금융결재원 정책에 따라 출금동의 증빙자료를 제출하지 않으면 자동이체 신청이 불가능합니다. 첨부한 증빙자료에 
                오류가 발생될 경우 자동이체 신청이 불가능할 수 있습니다. 회원 실명과 주민등록상의 실명, 예금주명이 일치하지 않으면 신청서 등록이 
                불가능합니다.</li>
          </ul>
        </div><!--//rew19_popup_cont-->
        <div class="rew19_popup_btn rew19_clear">
          <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
          <button class="rew19_popHarf activation" @click="onClickStep2Ok">신청</button>
        </div>        
      </div>
      <!--//STEP 2-->

      <!--STEP 3-->
      <div v-show="viewData.processStep==3" 
        class="tab-pane fade in active">
        <div class="rew19_popup_cont tab-content">
          <div class="rew19_messageBox icon_check">
            <p class="rew19_txtcenter">
              자동이체 계좌등록 신청이 완료되었습니다.<br/>
              회원님이 신청하신 계좌이체 정보는 다음과 같습니다.
            </p>
          </div>
          <dl class="rew19_select_table">
            <dt>
              <span class="rew19_table_tit">신청자 정보 입력</span>
            </dt>
            <dd>
              <ul class="rew19_oneline_stress">
                <li><em class="stress_type1">은행명</em> <span class="variable">{{viewData.step3.bankInfo.bankName}}</span></li>
                <li><em class="stress_type1">계좌번호</em> <span class="variable">{{viewData.step3.bankAccount}}</span></li>
                <li><em class="stress_type1">예금주</em> <span class="variable">{{viewData.step3.depositor}}</span></li>
              </ul>
            </dd>
          </dl>
          <ul class="rew19_dotList topLine">
            <li>영업일 기준 2일 뒤 계좌이체 등록이 진행된 후 계좌이체를 통한 정기구매 신규 신청이 가능합니다.
                카드결제를 선택하시면 즉시 정기구매 신청이 가능합니다.
            </li>
          </ul>
        </div><!--//rew19_popup_cont-->
        <div class="rew19_popup_btn">
          <button @click="onOk" class="rew19_popFull activation">닫기</button>
        </div>
      </div>
    </div>
    <!--//STEP 3-->

    <!-- SMS 승인 -->
    <sms-approval-dialog
      :title="'계좌등록 휴대폰 인증'"
      :show="smsApprovalDialogShow"
      @close="smsAppvovalDialogClose"
      ref="step2.smsApprovalDialog"
    ></sms-approval-dialog>  
  </div>  
</template>
<script>
import AroBase from '@/components/base/AroBase';
import SmsApprovalDialog from './SmsApprovalDialog';
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import * as Common from "@/utils/common";

const DEFAULT_VIEWDATA = {
  processStep : 1,

  step1:{
    isTermCheck: false
  },
  step2:{
    bankList : [
      {bankCode:"", bankName:"선택하세요"}
    ],
    checkedSms : false,
    checkedAccount : false,

    mobilePhoneNum1 : null,
    mobilePhoneNum2 : null,
    mobilePhoneNum3 : null,    

    memberName : null,
    depositor : null,
    bankInfo : {},
    bankAccount : null,
    birthday : null,    
    mobilePhoneNum : null,
    approvalStatus : null,
    file : null,
  },
  step3:{
    memberName : null,
    depositor : null,
    bankInfo : {},
    bankAccount : null,
    birthday : null,    
    mobilePhoneNum : null,
    approvalStatus : null,
  }
};



export default {
  name: 'BankAccountRegDialog',
  extends: AroBase,
  components: { SmsApprovalDialog },
  props: {
    show: {
      type: Boolean,
      default: false
    },    
  },
  data() {
    return {   
      currentZIndex : 2000,

      isExistCms : false,
      viewData : {...DEFAULT_VIEWDATA},

      bankAccountRegTerm : '',

      smsApprovalDialogShow : false,
      smsApprovalDialog : {}
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);
      
      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 146); 
    })
  },
  mounted() {
    let _this = this;

    _this.$http.get(_this.$aroApiBasePath + Const.VALUE_BANK_ACCOUNT_REG_TERM).then(res=>{
      _this.bankAccountRegTerm = res.data;
    });   
  },  
  methods :{
    onClose(response) {
      let _this = this;
      _this.smsApprovalDialogShow = false;
      
      _this.$emit('close', response, null);
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      this.onClose(true);
    },

    /**
     * API Request
     */      
    //은행 목록 가져오기
    apiGetBankList(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/banks`, {
        params: {}        
      });
    },

    //자동이체 계좌 인증
    apiCheckBankAccount(data){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/bank_verification`, {
        params: {
          ...data,
          //depositor : data.depositor,
          //bank_code : data.bankInfo.bankCode,
          //bank_account : data.bankAccount,          
        }          
      });
    },

    //자동이체 계좌신청 및 계좌 재신청
    apiRequestCms(data){
      let _this = this;

      const formData = new FormData();
      formData.append("member_name", data.member_name);
      formData.append("depositor", data.depositor);
      formData.append("bank_code", data.bank_code);
      formData.append("bank_account", data.bank_account);
      formData.append("birth_dt", data.birth_dt);
      formData.append("mobile_phone_num", data.mobile_phone_num);
      formData.append("approval_status", data.approval_status);
      formData.append("file", data.file);

      return _this.$http.post(`${_this.$aroApiBasePath}/aro/cms`, 
        formData,{
          "Content-Type" : "multipart/form-data"
        }        
      );
    },

    /**
     * Local 
     */
    initData(data){
      let _this = this;

      _this.isExistCms = data.isExistCms;

      _this.viewData = {
        ...DEFAULT_VIEWDATA,
      }
      _this.viewData.step1.isTermCheck = false; //약관동의 초기화

      _this.viewData.processStep = 1;
      _this.loadBankList();
    },

    //은행코드 로드
    loadBankList(){
      let _this = this;

      _this.$showLoading();
      _this.apiGetBankList().then(res=>{
          
        if (res.status === 200 && res.data.status === "0000") {

          //Step3로 이동
          _this.viewData.step2.bankList = [
            {bankCode:"", bankName:"선택하세요"},
            ...res.data.bankList
          ];
          _this.viewData.step2.bankInfo = _this.viewData.step2.bankList[0];
          return;
        }

        //오류
        let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
        _this.$dialogs.alert(errMsg)
        .then(res => {});        

      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //step1
    onClickStep1Ok(){
      let _this = this;

      if(!_this.viewData.step1.isTermCheck){        
        _this.$dialogs.alert("약관에 동의하셔야 신청이 가능합니다.")
        .then(res => {
          _this.$refs["step1.termCheck"].focus();
        });
        return;
      }

      //메시지 처리(이미 계좌가 등록된 경우)      
      if(_this.isExistCms){
        let msg = `회원님은 이미 계좌등록을 하셨습니다.<br/>
          새로운 계좌등록이 가능하며, 기존 등록된 계좌는 해지 신청됩니다.<br/>
          등록 하시겠습니까?`;
        
        _this.$dialogs.confirm(msg, {cancelLabel: '취소', okLabel:'확인'}).then(res=>{
          if(res.ok){
            _this.viewData.processStep = 2;
          }
        });
        return;
      }

      _this.viewData.processStep = 2;
    },

    //핸드폰 번호 변경시
    onChnageMobilePhone(){
      let _this = this;
      _this.viewData.step2.checkedSms = false;
      _this.viewData.step2.approvalStatus = null;      
    },

    //SMS 승인창 Open
    openSmsApprovalDialog(){
      let _this = this;

      if(!_this.validateSmsPhoneNumber()){
        return;
      }

      //인증창 open
      _this.viewData.step2.checkedSms = false;      
      _this.smsApprovalDialogShow = true;  

      _this.smsApprovalDialog = {
        ..._this.smsApprovalDialog,
        ..._this.viewData.step2       
      };
      _this.$refs["step2.smsApprovalDialog"].initData(_this.smsApprovalDialog);      
    },

    //SMS 인증 유효성 검사
    validateSmsPhoneNumber(){
      let _this = this;
      let rexExOnlyNum = /^[0-9]*$/;
      let chVal = "";

      chVal = _this.viewData.step2.mobilePhoneNum1;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("휴대폰 첫번째 자리를 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs["step2.mobilePhoneNum1"].focus();
        });   
        return false;
      }
      
      if(!rexExOnlyNum.test(chVal)){
        _this.$dialogs.alert("휴대폰 첫번째 자리에 숫자만 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs["step2.mobilePhoneNum1"].focus();
        });   
        return false;
      }

      chVal = _this.viewData.step2.mobilePhoneNum2;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("휴대폰 가운데 자리를 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs["step2.mobilePhoneNum2"].focus();
        });   
        return false;
      }

      if(!rexExOnlyNum.test(chVal)){
        _this.$dialogs.alert("휴대폰 가운데 자리에 숫자만 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs["step2.mobilePhoneNum2"].focus();
        });   
        return false;
      }

      chVal = _this.viewData.step2.mobilePhoneNum3;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("휴대폰 마지막 자리를 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs["step2.mobilePhoneNum3"].focus();
        });   
        return false;
      }

      if(!rexExOnlyNum.test(chVal)){
        _this.$dialogs.alert("휴대폰 마지막 자리에 숫자만 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs["step2.mobilePhoneNum3"].focus();
        });   
        return false;
      }

      return true;
    },

    //SMS 승인창 close 시
    smsAppvovalDialogClose(isOk, data){
      let _this = this;

      _this.smsApprovalDialogShow = false;
                
      if(!isOk){
        //Do nothing
        return;
      }

      if(isOk && data.checkedSms){
        _this.viewData.step2.checkedSms = true;
        _this.viewData.step2.approvalStatus = data.approvalStatus;
      }
    },

    //계좌정보 변경시
    onChnageBankAccount(){
      let _this = this;
      _this.viewData.step2.checkedAccount = false;
    },

    //계좌인증
    onClickCheckAccountInfo(){
      let _this = this;

      if(!_this.validateAccountInput()){
        return;
      }

      //계좌인증
      let step2Data = _this.viewData.step2;
      let paramData = {
        depositor : step2Data.depositor,
        bankCode : step2Data.bankInfo.bankCode,
        bankAccount : step2Data.bankAccount,        
      };

      _this.viewData.step2.checkedAccount = false;
      _this.$showLoading();
      _this.apiCheckBankAccount(paramData).then(res=>{
        
        if (res.status === 200 && res.data.status === "0000") {          
          _this.viewData.step2.checkedAccount = true;
          _this.$dialogs.alert("계좌인증에 성공하였습니다.")
          .then(res => {});
          return;
        }

        //오류        
        let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;          
        _this.$dialogs.alert(errMsg)
        .then(res => {});        

      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });

    },

    //계좌정보 입력 유효성 검사
    validateAccountInput(){
      let _this = this;
      let rexExOnlyNum = /^[0-9]*$/;
      let chVal = "";

      //결제은행
      chVal = _this.viewData.step2.bankInfo.bankCode;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("결제은행을 선택해 주십시오.")
        .then(res => {
          _this.$refs["step2.bankInfo"].focus();
        });   
        return false;
      }

      //예금주
      chVal = _this.viewData.step2.depositor;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("예금주를 입력해 주십시오.")
        .then(res => {
          _this.$refs["step2.depositor"].focus();
        });   
        return false;
      }

      //계좌번호
      chVal = _this.viewData.step2.bankAccount;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("계좌번호를 입력해 주십시오.")
        .then(res => {
          _this.$refs["step2.bankAccount"].focus();
        });   
        return false;
      }

      if(!rexExOnlyNum.test(chVal)){
        _this.$dialogs.alert("계좌번호를 숫자로만 입력해 주십시오.")
        .then(res => {
          _this.$refs["step2.bankAccount"].focus();
        });   
        return false;
      }

      return true;
    },

    //첨부파일 변경시
    onChangeAttachFile(){
      let _this = this;

      _this.viewData.step2.file = _this.$refs["step2.attachFile"].files[0];

      let path = _this.$refs["step2.attachFile"].value;
      _this.$refs["step2.fakePath"].value = path;
    },

    //CMS 신청
    onClickStep2Ok(){
      let _this = this;

      if(!_this.validateCmsInput()){
        return;
      }

      //CMS 신청
      let step2Data = _this.viewData.step2;
      let paramData = {
        member_name : _this.getMemberNmKr(),
        depositor : step2Data.depositor,
        bank_code : step2Data.bankInfo.bankCode,
        bank_account : step2Data.bankAccount,
        birth_dt : step2Data.birthday,
        mobile_phone_num : `${step2Data.mobilePhoneNum1}-${step2Data.mobilePhoneNum2}-${step2Data.mobilePhoneNum3}`,
        approval_status : step2Data.approvalStatus,
        file : step2Data.file
      };
      _this.$showLoading();
      _this.apiRequestCms(paramData).then(res=>{
          
        if (res.status === 200 && res.data.status === "0000") {

          //Step3로 이동
          _this.viewData.step3 = {
            ...step2Data
          };
          _this.viewData.processStep = 3;
          return;
        }

        //오류
        let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
        _this.$dialogs.alert(errMsg)
        .then(res => {});        

      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //계좌 입력정보 유효성 검사
    validateCmsInput(){
      let _this = this;
      let rexExOnlyNum = /^[0-9]*$/;
      let chVal = "";

      //휴대폰 인증 확인
      if(!_this.viewData.step2.checkedSms){
        _this.$dialogs.alert("휴대폰 인증을 진행해 주십시오.")
        .then(res => {
          _this.$refs["step2.mobilePhoneNum1"].focus();
        });   
        return false;
      }

      //계좌인증 확인
      if(!_this.viewData.step2.checkedAccount){
        _this.$dialogs.alert("계좌 인증을 진행해 주십시오.")
        .then(res => {
          _this.$refs["step2.bankAccount"].focus();
        });   
        return false;
      }

      //생년월일
      chVal = _this.viewData.step2.birthday;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("생년월일 입력해 주십시오.")
        .then(res => {
          _this.$refs["step2.birthday"].focus();
        });   
        return false;
      }

      let regExBirth = /^\d{2}(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
      if(!regExBirth.test(chVal)){
        _this.$dialogs.alert("생년월일 6자리 숫자로 입력해 주십시오.")
        .then(res => {
          _this.$refs["step2.birthday"].focus();
        });   
        return false;
      }

      //첨부파일
      if(!_this.$refs["step2.attachFile"].files[0]){
        _this.$dialogs.alert("동의서를 첨부해 주십시오.")
        .then(res => {
          _this.$refs["step2.attachFile"].focus();
        });   
        return false;
      }
      _this.viewData.step2.file = _this.$refs["step2.attachFile"].files[0];

      return true;
    },

    /**
     * Util
     */
    numberKeyPress(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    keyUpToNumber(evt){
      evt = (evt) ? evt : window.event;
      evt.target.value = evt.target.value.replace(/[^0-9]/g, "");
    },    
  }
}
</script>
<style>
h2 button { display: block !important; }
ul.num {
  margin-inline-start:20px;
}
ul.num li{
  list-style-type: decimal;
}

.rew19_btn_T1, .rew19_wrapCheck_t1 label{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/BankAccountRegDialog.vue